import { Icon, IconProps, MergeWithAs } from "@chakra-ui/react";
import FeatherIcon, { IconComponentProps } from "@ailibs/feather-react-ts";
import { SVGProps } from "react";

export type ChakraFeatherIconProps = MergeWithAs<
  SVGProps<SVGSVGElement>,
  IconComponentProps,
  IconProps,
  typeof FeatherIcon
>;

export const ChakraFeatherIcon = (props: ChakraFeatherIconProps) => {
  return <Icon as={FeatherIcon} {...props} />;
};
